import React, { useState, useRef } from 'react';

import { AiOutlineClose } from 'react-icons/ai';
import { HiOutlineMenuAlt4 } from 'react-icons/hi';

import { Link } from "react-router-dom";


const Navbar = () => {
  const [nav, setNav] = useState(false);
  const [logo, setLogo] = useState(false)
  const handleNav = () => {
    setNav(!nav);
    setLogo(!logo)
  };


  const listyle = {
    color: "white",
    fontWeight: 600,
    textDecoration: "none",
    // color: '#b07e4d'

  };
  const moblistyle = {
    fontWeight: 600,
    textDecoration: "none",
    color: '#b07e4d'
  };


  return (
    <div className='flex w-full justify-between items-center h-20 px-4 absolute z-10 text-white'>
      <div>
        {/* <h1 onClick={handleNav} className={logo ? 'hidden' : 'block'}>alnokhatha.ae</h1> */}
        <h1>alnokhatha.ae</h1>
      </div>
      <ul className='hidden md:flex' >
        <li ><Link to="/" style={listyle}> Home </Link></li>
        <li><a href="#cp" style={listyle}> Our Companies </a></li>
        <li> <a href="#about" style={listyle}>About Us</a></li>
        <li><a href="#map" style={listyle}> Contact Us </a></li>
        {/* <li>عربى</li> */}
      </ul>
      {/* <div className='hidden md:flex'>
        <BiSearch className='' size={20} />
        <BsPerson size={20} />
      </div> */}

      {/* Hamburger */}
      <div onClick={handleNav} className='md:hidden z-10'>
        {nav ? <AiOutlineClose className='text-black' size={20} /> : <HiOutlineMenuAlt4 size={20} />}
      </div>

      {/* Mobile menu dropdown */}
      <div onClick={handleNav} className={nav ? 'absolute text-black left-0 top-0 w-full bg-gray-100/90 px-4 py-7 flex flex-col' : 'absolute left-[-100%]'}>
        <ul>
          <h1>alnokhatha.ae</h1>
          <li className='border-b'><a href="/" style={moblistyle}> Home </a></li>
          <li className='border-b'><a href="#cp" style={moblistyle} > Our Companies </a></li>
          <li className='border-b'><a href="#about" style={moblistyle}> About Us</a></li>
          <li className='border-b'><a href="#map" style={moblistyle}> Contact Us </a></li>
          {/* <div className='flex flex-col'>
            <button className='my-6'>Search</button>
            <button>Account</button>
          </div>
          <div className='flex justify-between my-6'>
            <FaFacebook className='icon' />
            <FaTwitter className='icon' />
            <FaYoutube className='icon' />
            <FaPinterest className='icon' />
            <FaInstagram className='icon' />
          </div> */}
        </ul>
      </div>
    </div>
  );
};

export default Navbar;
